import { forwardRef } from "react";
import ChatImage from "../ChatImage";
import { IoMdClose } from "react-icons/io";
import DicomViewer from "./DicomViewer";
import { MimeTypes } from "@minohealth/common/utils/files";

import "./chat-image-viewer.css";

const ChatImageViewerBase = forwardRef(({ srcImage, bboxes, multiple = false, onCloseViewer, onGenerateReport, showGenerateReportBtn }, ref) => {
  const isImage = srcImage?.type === MimeTypes.PNG || srcImage?.type === MimeTypes.JPEG;
  const isDicom = srcImage?.type === MimeTypes.DICOM;

  return (
    <dialog
      className="diagnose-chat__patient-image-viewer"
      data-papaya-container={multiple}
      ref={ref}
      onClick={(e) => {
        if (e.target !== ref.current) return;
        onCloseViewer?.();
      }}
      onCancel={(e) => {
        e.preventDefault();
        onCloseViewer?.();
      }}
      onClose={onCloseViewer}
    >
      {multiple
        ? (
          <div className="papaya" data-params="params"></div>
        ) : srcImage ? (
          <div className="diagnose-chat__patient-image-viewer-body" data-type={srcImage?.type}>
            <button
              className="diagnose-chat__patient-image-viewer-close-btn"
              onClick={onCloseViewer}
            >
              <IoMdClose />
            </button>

            {isImage && (
              <div className="diagnose-chat__patient-image-viewer-img-wrapper">
                <ChatImage srcImage={srcImage} alt="chat image" />

                <div className="chat-image-view__bboxes-wrapper">
                  {bboxes?.map((bBox, index) => (
                    bBox != null && (
                      <div
                        className="chat-image-view__bbox"
                        style={{
                          "--_left": `${bBox.left}`,
                          "--_top": `${bBox.top}`,
                          "--_width": `${bBox.width}`,
                          "--_height": `${bBox.height}`,
                          // "--_color": `${bBox.color}`,
                          "--_delay": `${index * 50}ms`,
                        }}
                        key={index}
                      ></div>
                    )
                  ))}
                </div>

                {showGenerateReportBtn && onGenerateReport && (
                  <button
                    className="absolute bottom-4 right-4 bg-[var(--AppAccentGreen)] hover:bg-[var(--AppButtonHover)] text-background font-bold py-2 px-4 rounded-lg shadow-lg transition-all z-50 text-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      onGenerateReport(srcImage);
                      onCloseViewer();
                    }}
                  >
                    Generate Report
                  </button>
                )}
              </div>
            )}

            {isDicom && (
              <div className="diagnose-chat__patient-image-viewer-dicom-wrapper">
                <DicomViewer srcImage={srcImage} />
              </div>
            )}
          </div>
        ) : null
      }
    </dialog>
  );
});

export default ChatImageViewerBase;